import { gql } from 'graphql-request'

class OfferMutations {
  createOffer = gql`
    mutation CreateOffer($data: OfferCreateInput!) {
      createOffer(data: $data) {
        id
        title
        customer {
          id
          name
        }
        places {
          id
          name
        }
        type
        createdAt
        earnableFrom
        earnableTo
        redeemableFrom
        redeemableTo
        categories {
          id
          name
        }
        image {
          url
        }
        termsAndConditions
        howToRedeem
        description
        cost
        maxClaimable
        nbPermittedClaims
        qrCode {
          url
        }
        activeMessage
      }
    }
  `

  updateOffer = gql`
    mutation UpdateOffer($where: OfferWhereUniqueInput!, $data: OfferUpdateInput!) {
      updateOffer(where: $where, data: $data) {
        id
        title
        customer {
          id
          name
        }
        places {
          id
          name
        }
        type
        createdAt
        earnableFrom
        earnableTo
        redeemableFrom
        redeemableTo
        categories {
          id
          name
        }
        image {
          url
        }
        termsAndConditions
        howToRedeem
        description
        cost
        maxClaimable
        nbPermittedClaims
        qrCode {
          url
        }
        activeMessage
      }
    }
  `
  deleteOffers = gql`
    mutation DeleteOffers($where: OffersWhereIdsInput!) {
      deleteOffers(where: $where) {
        count
      }
    }
  `
}

const offerMutations = new OfferMutations()

export default offerMutations
